import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=794829f2&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=ts&"
export * from "./Avatar.vue?vue&type=script&lang=ts&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=794829f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794829f2",
  null
  
)

export default component.exports